module.exports = __webpack_public_path__ + "img/xls.521dec4a.png";